module.exports = __webpack_public_path__ + "img/Patch14-2.5afb546c.webp";